/* eslint-disable no-unsafe-optional-chaining */
import * as React from 'react';
import 'twin.macro';
import { useRouter } from 'next/router';
import { GetStaticProps } from 'next';
import { useHydrateAtoms } from 'jotai/utils';

import { /* createRestaurantsService, createTaxonomyService, */ globalServices } from '@restworld/data-services';
import { Spinner } from '@restworld/ui-ds';

import { JobExplorerComponentPropType } from '../../components/job-explorer/job-explorer.types';
import { JobExplorer } from '../../components/job-explorer';
import { getJobPositionCoordinates, getJobPositionList } from './[filter_slug]';
import { defaultJobListPayload } from '../../components/job-explorer/job-explorer.types';
import {
  domainInterestAtom,
  serverListPayloadAtom,
  serverCoordinatePayloadAtom,
  jobPositionCoordinatesFromServerAtom,
  jobPositionListFromServerAtom,
} from '../../components/job-explorer/job-explorer-server.atoms';
import { jobLocationPositionListAtom } from '../../components/job-explorer/job-explorer-list.atoms';
import { jobLocationCoordinatesAtom } from '../../components/job-explorer/job-explorer-map.atoms';
import { getServerTranslations } from '../../lib/i18n/getServerTranslations';

export const baseUrl = process.env.NEXT_PUBLIC_BASE_API_URL;

type IIndexProps = JobExplorerComponentPropType;
export const ExplorerPageIndex: React.FunctionComponent<IIndexProps> = (props) => {
  const { isFallback } = useRouter();
  useHydrateAtoms([
    [domainInterestAtom, props.domainInterest],
    [jobLocationPositionListAtom, props.jobPositionListFromServer?.data],
    [jobLocationCoordinatesAtom, props.jobPositionCoordinatesFromServer],
    [serverListPayloadAtom, props.serverListPayload],
    [serverCoordinatePayloadAtom, props.serverCoordinatePayload],
    [jobPositionListFromServerAtom, props.jobPositionListFromServer?.data],
    [jobPositionCoordinatesFromServerAtom, props.jobPositionCoordinatesFromServer],
  ]);
  if (isFallback)
    return (
      <div tw="fixed top-[50%] left-[50%] -mt-[50px] -ml-[50px]">
        <Spinner color="primary" size="md" />
      </div>
    );
  return <JobExplorer />;
};
export default ExplorerPageIndex;

export const getStaticProps: GetStaticProps<IIndexProps> = async ({ locale }) => {
  let serverProps = {
    props: {
      domainInterest: null,
      // popularLocalities: null,
      // popularOccupations: null,
      jobPositionListFromServer: null,
      jobPositionCoordinatesFromServer: null,
    },
  };
  const transConfig = await getServerTranslations(locale, ['common', 'job-explorer-page', 'auth-flow']);
  try {
    const [
      domainInterest,
      // popularOccupations,
      // popularLocalities,
      jobPositionListFromServer,
      jobPositionCoordinatesFromServer,
    ] = await Promise.all([
      globalServices({ baseUrl }).fetchVariableOptions('domain_interest'),
      // createTaxonomyService({ baseUrl }).fetchPopularOccupations(10),
      // createRestaurantsService({ baseUrl }).fetchPopularLocalities(10),
      getJobPositionList({ payload: { ...defaultJobListPayload } }),
      await getJobPositionCoordinates({}),
    ]);

    const props = {
      domainInterest: domainInterest?.data,
      // popularOccupations: popularOccupations?.data,
      // popularLocalities: popularLocalities?.data,
      jobPositionListFromServer,
      jobPositionCoordinatesFromServer,
      ...transConfig,
    };
    serverProps = {
      props,
    };
  } catch (error) {
    console.error(`error fetching options`, error);
  }
  return serverProps;
};
